import { render, staticRenderFns } from "./RuleItem.vue?vue&type=template&id=7457fe5c&"
import script from "./RuleItem.vue?vue&type=script&lang=ts&"
export * from "./RuleItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports